import React from "react";

const stats = [
  { k: "7+", v: "Years in business" },
  { k: "240+", v: "Projects delivered" },
  { k: "6", v: "States serviced" },
  { k: "98%", v: "Client satisfaction" },
];

export default function About() {
  return (
    <section id="studio" data-testid="section-about" className="relative bg-bone py-24 md:py-40 grain">
      <div className="w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12 grid grid-cols-12 gap-8 relative">
        <p className="label col-span-12 md:col-span-2 reveal">02 — About Virarc</p>

        <div className="col-span-12 md:col-span-7 reveal">
          <h2 className="display text-[9vw] md:text-6xl lg:text-[5rem] leading-[1.02] tracking-tighter">
            Design thinking, technical precision, construction expertise —
            <span className="italic font-light text-rust"> under one roof.</span>
          </h2>
          <p className="mt-10 text-lg leading-relaxed text-muted2 max-w-2xl">
            Virarc was founded on a simple idea: a building turns out better when the same team designs, documents and delivers it. From our studio in Adelaide we work across Australia on residential, commercial and industrial projects built to last.
          </p>
        </div>

        <aside className="col-span-12 md:col-span-3 md:col-start-10 reveal">
          <div className="relative overflow-hidden aspect-[3/4]">
            <img
              src="https://images.pexels.com/photos/12277631/pexels-photo-12277631.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Virarc studio"
              className="w-full h-full object-cover"
            />
          </div>
          <p className="label mt-4">Adelaide · South Australia HQ</p>
        </aside>

        {/* Stats — asymmetric bento */}
        <div className="col-span-12 mt-20 md:mt-28 grid grid-cols-2 md:grid-cols-4 gap-px bg-ink/10 reveal">
          {stats.map((s, i) => (
            <div key={s.k} className={`bg-bone p-8 md:p-12 ${i === 1 ? "md:translate-y-6" : ""} ${i === 3 ? "md:-translate-y-6" : ""}`}>
              <p className="display text-6xl md:text-7xl lg:text-8xl text-ink">{s.k}</p>
              <p className="label mt-4">{s.v}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
